var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagicUploadSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.06974 1.26759C5.06974 4.44392 7.3511 7.04268 10.139 7.04268C7.3511 7.04268 5.06974 9.64145 5.06974 12.8178C5.06974 9.64145 2.78838 7.04268 0 7.04268C2.78787 7.04268 5.06974 4.44392 5.06974 1.26759ZM12.6369 0C12.6369 2.10715 14.1502 3.83103 16 3.83103C14.1502 3.83103 12.6369 5.5549 12.6369 7.66205C12.6369 5.5549 11.1236 3.83103 9.27377 3.83103C11.1236 3.83103 12.6369 2.10715 12.6369 0ZM11.2026 9.46482C11.2026 11.2623 12.4937 12.7324 14.0711 12.7324C12.4932 12.7324 11.2026 14.2031 11.2026 16C11.2026 14.2025 9.91155 12.7324 8.33414 12.7324C9.91207 12.7324 11.2026 11.2617 11.2026 9.46482Z",
    fill: "url(#paint0_linear_9222_11168)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9222_11168",
    x1: 0,
    y1: 8,
    x2: 16,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4087C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413462,
    stopColor: "#A268AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826923,
    stopColor: "#E94793"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F05624"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicUploadSvg);
export default __webpack_public_path__ + "static/media/MagicUploadSvg.f1adb6f66de47f75f36861ee05fb85b6.svg";
export { ForwardRef as ReactComponent };